import './admin-header.scss';
import { ActionWidget } from '../action-widget/action-widget';
import { Button } from '../../components/form/button';
import Icon from '../../components/icons/icon';
import { useLocation, matchRoutes } from 'react-router-dom';
import classNames from 'classnames';
import { openEcommerceSite } from './utils/admin-header-utils';

export const AdminHeader = ({
  pathsToRemoveActions,
  className,
}: {
  pathsToRemoveActions: string[];
  className?: string;
}) => {
  const location = useLocation();
  const match = matchRoutes(
    pathsToRemoveActions.map((path) => ({ path })),
    location,
  );

  return !match ? (
    <div className={classNames('admin-header', className)}>
      <div className="action-widget">
        <Button className="widget-btn" onClick={openEcommerceSite}>
          <Icon icon="World" />
        </Button>
      </div>
      <ActionWidget />
    </div>
  ) : null;
};
